import React from 'react';
import { NamedLink } from '../../../components';
import { DIGO_CLIENT_USER_TYPE, signupLinkProps } from '../digoServices';
import css from './SectionTrustDigo.module.css';

const FEATURES = [
  {
    id: 'payment',
    title: 'Paiement sécurisé',
    desc:
      "L'argent est retenu jusqu'à ce que la tâche soit complétée à ta satisfaction. Aucun frais caché.",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect fill="none" x="3" y="11" width="18" height="11" rx="2" />
        <path fill="none" d="M7 11V7a5 5 0 0110 0v4" />
      </svg>
    ),
  },
  {
    id: 'reviews',
    title: 'Évaluations vérifiées',
    desc:
      'Choisis le bon travailleur grâce aux vraies évaluations et aux notes laissées par la communauté.',
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <polygon
          fill="none"
          points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
        />
      </svg>
    ),
  },
  {
    id: 'insurance',
    title: 'Travailleurs vérifiés',
    desc: "Antécédents judiciaires et identité vérifiés à l'inscription.",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path fill="none" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline fill="none" points="9 12 11 14 15 10" />
      </svg>
    ),
  },
];

const SectionTrustDigo = () => (
  <section className={css.root}>
    <div className={css.container}>
      {/* Photo */}
      <div className={css.photoWrap}>
        <img
          src="/static/digo-satisfied-woman-customer.webp"
          alt="Travailleur certifié DIGO souriant"
          className={css.photo}
          loading="lazy"
        />
        <div className={css.ratingCard}>
          <div className={css.ratingTop}>
            <img
              src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=48&h=48&fit=crop&crop=face&auto=format"
              alt=""
              className={css.ratingAvatar}
            />
            <div>
              <div className={css.ratingName}>Jean-François M.</div>
              <div className={css.ratingStars}>★★★★★</div>
            </div>
          </div>
          <p className={css.ratingText}>"Ponctuel, soigneux, super pro. Je recommande !"</p>
        </div>
      </div>

      {/* Features */}
      <div className={css.features}>
        <h2 className={css.title}>
          Confiance et sécurité,
          <br />
          pour ta tranquillité.
        </h2>
        <p className={css.subtitle}>
          Chaque tâche sur DIGO est protégée — avant, pendant et après.
        </p>

        <div className={css.featureList}>
          {FEATURES.map(f => (
            <div key={f.id} className={css.feature}>
              <div className={css.featureIcon}>{f.icon}</div>
              <div>
                <div className={css.featureTitle}>{f.title}</div>
                <div className={css.featureDesc}>{f.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <NamedLink {...signupLinkProps(DIGO_CLIENT_USER_TYPE)} className={css.cta}>
          Publier une annonce
        </NamedLink>
      </div>
    </div>
  </section>
);

export default SectionTrustDigo;
